import { util, type Canvas } from 'fabric';

let isAnimating = false;

const rotateItem = (canvas: Canvas): void => {
  if (isAnimating) return;
  const activeObj = canvas.getActiveObject();
  if (!activeObj) return;

  const right = 45;
  const flipThreshold = 25;
  const angle = (activeObj.get('angle') as number) + right;

  activeObj.animate(
    { angle },
    {
      duration: 275,
      easing: util.ease.easeOutBack,
      onChange: (ang: number) => {
        // eslint-disable-next-line unicorn/no-top-level-assignment-in-function -- module-scoped animation lock preventing overlapping rotate animations (read at the top of rotateItem)
        isAnimating = true;
        // if the goal is rotated 180 degrees, bring it to the top of the stack,
        // and flip it so that it looks like it hasn't been rotated at all
        if (ang % 360 > 90 + flipThreshold) {
          activeObj.set('flipY', true);
          canvas.bringObjectToFront(activeObj);
        }
        if (ang % 360 > 180 + flipThreshold) {
          activeObj.set('flipY', false);
          canvas.sendObjectToBack(activeObj);
        }
        // Diagonal angle left, doesn't work like the comment above.
        if (
          ang % 360 < 225 + flipThreshold &&
          ang % 360 > 180 + flipThreshold
        ) {
          activeObj.set('flipY', true);
          canvas.sendObjectToBack(activeObj);
        }

        canvas.requestRenderAll();
      },
      onComplete: () => {
        // eslint-disable-next-line unicorn/no-top-level-assignment-in-function -- module-scoped animation lock (see above)
        isAnimating = false;
      },
    },
  );
};

export default rotateItem;
